import { LoadingButton } from '@mui/lab'
import { Button, Card, CardActions, CardContent, CardHeader } from '@mui/material'
import { PropsWithChildren, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

interface Props extends PropsWithChildren {
  title: ReactNode
  loading?: boolean
  onReset: () => void
  onSubmit: () => void
}

function InputFormCard (props: Props) {
  const { t } = useTranslation()

  const {
    title,
    children,
    loading,
    onReset,
    onSubmit,
  } = props

  return (
    <Card>
      <CardHeader title={title} />
      <CardContent className="flex flex-col gap-16 overflow-auto">
        {children}
      </CardContent>
      <CardActions>
        <Button
          variant="text"
          onClick={onReset}
        >
          {t('WORD.RESET')}
        </Button>
        <LoadingButton
          variant="contained"
          onClick={onSubmit}
          loading={loading}
        >
          {t('WORD.CALCULATE')}
        </LoadingButton>
      </CardActions>
    </Card>
  )
}

export default InputFormCard
